import { useCallback } from 'react';
import styled, { css } from 'styled-components';

import { capitalize, useToggle, CheckboxField } from '../../../../../common';
import { SelectablePlaylistButton } from '../../../shared';

import { useTunifyGreen } from '../tunifyGreenProvider';
import { CategoryTypes } from '../types';

const StyledSelectablePlaylistButton = styled(SelectablePlaylistButton)`
  padding: 0.85rem 0.5rem 0.85rem 1.5rem;

  &:after {
    width: 100%;
  }

  ${({ isOver, theme }) =>
    isOver &&
    css`
      background-color: ${theme.dark400};
    `}
`;

const Channel = ({ calendar }) => {
  const { dispatch, selectedCategory } = useTunifyGreen();

  const [isSelected, toggleIsSelected] = useToggle(calendar?.selected ?? false);

  const handleClickListItem = useCallback(() => {
    dispatch({
      selectedCalendarType: CategoryTypes.CUSTOM,
      selectedCalendar: calendar,
    });
  }, [dispatch, calendar]);

  const handleClickCheckbox = useCallback(
    (event) => event.stopPropagation(),
    []
  );

  return (
    <StyledSelectablePlaylistButton
      key={calendar.calendarId}
      onClick={handleClickListItem}
      selected={selectedCategory?.id === calendar.calendarId}
      type="button"
      value={calendar.calendarId}
    >
      <p>{capitalize(calendar.title)}</p>
      <CheckboxField
        onChange={toggleIsSelected}
        onClick={handleClickCheckbox}
        checked={isSelected}
      />
    </StyledSelectablePlaylistButton>
  );
};

export default Channel;
